<script>
    import { page } from '$app/stores';
</script>

<svelte:window on:keydown={(event) => event.code === 'Escape' && history.back()} />

<section class='maincontent'>
    <div class='center'>
        <div class='flavor'>
            <p>
                <span>You have died</span>
                <span>Press ESC to continue.</span>
            </p>
            <div>
                <img class='slain' src='/static/img/dead.png' alt='Slain Sorceress' />
            </div>
        </div>
        <div class='error'>
            <p class='message'>
                {#if $page.status === 401}
                    401 | Unauthorized
                {:else if $page.status === 403}
                    403 | Forbidden
                {:else if $page.status === 404}
                    404 | Not Found
                {:else if $page.status === 500}
                    500 | {@html $page.error?.message || 'Internal Error'}
                {:else}
                    {$page.status} | {@html $page.error?.message || 'Server Down'}
                {/if}
            </p>
            {#if $page.error?.errorId}
                <p class='errorid'>
                    ID: {$page.error?.errorId}
                </p>
            {/if}
        </div>
    </div>
</section>

<style>
    .center {
        margin: var(--font-size-8xl) auto;
        display: flex;
        flex-direction: column;
        gap: var(--gap-5);
    }
    .center > div {
        flex: 1;
        margin: auto;
    }
    .flavor > p {
        font-family: var(--font-family-d2);
        color: rgb(202, 23, 0);
        text-shadow: 2px 2px 1px #000000;
        font-size: var(--font-size-5xl);
        line-height: var(--line-height-5xl);
    }
    .flavor > p {
        display: flex;
        flex-direction: column;
    }
    .flavor span {
        margin: auto;
        text-align: center;
    }
    .flavor > div {
        margin-top: var(--gap-5);
        text-align: center;
    }
    .slain {
        filter: saturate(1.2);
    }
    .error {
        font-family: var(--font-family-alt);
        color: var(--font-color-base-muted);
    }
    .message {
        font-size: var(--font-size-5xl);
        line-height: var(--line-height-5xl);
        margin-bottom: var(--gap-3);
    }
    .errorid {
        text-transform: uppercase;
    }
</style>